var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout-footer",
    [
      _c(
        "q-toolbar",
        {
          staticClass: "q-py-lg footer-desktop mobile-hide",
          style: _vm.$q.platform.is.edge ? "height: 180px" : ""
        },
        [
          _c("div", { staticClass: "row fit justify-center" }, [
            _c("div", { staticClass: "col-sm-10" }, [
              _c("div", { staticClass: "row gutter-md" }, [
                _c("div", { staticClass: "col-3" }, [
                  _c(
                    "div",
                    { staticClass: "row  gutter-xs flex justify-center" },
                    [
                      _c("div", { staticClass: " col-12 logo text-center" }, [
                        _c("img", {
                          staticClass: "logo-footer-desktop",
                          attrs: { src: _vm.getLogo }
                        })
                      ]),
                      _vm.urlStoreGoogle && _vm.id_user_language_selected == 1
                        ? _c("div", { staticClass: "col-6" }, [
                            _c("a", { attrs: { href: _vm.urlStoreGoogle } }, [
                              _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  src: require("assets/store_icons/google_portugues.png")
                                }
                              })
                            ])
                          ])
                        : _vm._e(),
                      _vm.urlStoreGoogle && _vm.id_user_language_selected == 2
                        ? _c("div", { staticClass: "col-6" }, [
                            _c("a", { attrs: { href: _vm.urlStoreGoogle } }, [
                              _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  src: require("assets/store_icons/google_ingles.png")
                                }
                              })
                            ])
                          ])
                        : _vm._e(),
                      _vm.urlStoreGoogle && _vm.id_user_language_selected == 3
                        ? _c("div", { staticClass: "col-6" }, [
                            _c("a", { attrs: { href: _vm.urlStoreGoogle } }, [
                              _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  src: require("assets/store_icons/google_espanhol.png")
                                }
                              })
                            ])
                          ])
                        : _vm._e(),
                      _vm.urlStoreGoogle && _vm.id_user_language_selected == 4
                        ? _c("div", { staticClass: "col-6" }, [
                            _c("a", { attrs: { href: _vm.urlStoreGoogle } }, [
                              _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  src: require("assets/store_icons/google_frances.png")
                                }
                              })
                            ])
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("h5", { staticClass: "no-margin q-pb-md" }, [
                      _vm._v(_vm._s(_vm.$t("institutional")))
                    ]),
                    _vm._l(_vm.institutional, function(inst, index) {
                      return _c(
                        "p",
                        { key: index },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: inst.to } } },
                            [_vm._v(_vm._s(_vm.$t(inst.name)))]
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("h5", { staticClass: "no-margin q-pb-md" }, [
                      _vm._v(_vm._s(_vm.$t("questions")))
                    ]),
                    _vm._l(_vm.questions, function(question, index) {
                      return _c(
                        "p",
                        { key: index },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: question.to } } },
                            [_vm._v(_vm._s(_vm.$t(question.name)))]
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("h5", { staticClass: "no-margin q-pb-md" }, [
                      _vm._v(_vm._s(_vm.$t("access")))
                    ]),
                    _vm._l(_vm.links, function(link, index) {
                      return _vm.showLink(link.to)
                        ? _c(
                            "p",
                            { key: index },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: link.to } } },
                                [_vm._v(_vm._s(_vm.$t(link.name)))]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              ])
            ])
          ])
        ]
      ),
      _c(
        "q-toolbar",
        {
          staticClass: "mobile-hide bg-primary",
          staticStyle: { padding: "0px", "min-height": "30px" }
        },
        [
          _c(
            "q-toolbar-title",
            { staticClass: "text-center text-weight-light" },
            [
              _c("small", [
                _vm._v(
                  "Copyright © " +
                    _vm._s(new Date().getFullYear()) +
                    ": " +
                    _vm._s(_vm.getProjectName) +
                    " v" +
                    _vm._s(_vm.getVersion) +
                    "\n\t\t\t\t- Powered by "
                ),
                _c("a", { attrs: { href: "https://take5.com.br" } }, [
                  _vm._v("Take 5 LMS")
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "q-toolbar",
        { staticClass: "desktop-hide" },
        [
          _c("q-toolbar-title", { staticClass: "text-center" }, [
            _c("div", { staticClass: "logo" }, [
              _c("img", {
                staticClass: "logo-footer",
                attrs: { src: _vm.getLogo }
              })
            ])
          ]),
          _c("q-btn", {
            attrs: { flat: "", round: "", dense: "", icon: "far fa-bars" },
            on: {
              click: function($event) {
                return _vm.openMenu()
              }
            }
          })
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: "80vw",
              maxWidth: "100vw",
              minHeight: "90vh"
            }
          },
          on: {
            hide: function($event) {
              _vm.show_modal = false
            }
          },
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_modal = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("download_app")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }